export const PROJECT_PLACEMENTS = ['local', 'cloud'];
export const BUILD_AGENT_MODELS = ['claude-opus-4-8', 'claude-fable-5'];
export const DEFAULT_BUILD_AGENT_MODEL = 'claude-opus-4-8';
export function resolveProjectPlacement(value) {
    return value === 'cloud' ? 'cloud' : 'local';
}
export function resolveBuildAgentModel(value) {
    return value === 'claude-fable-5' ? value : DEFAULT_BUILD_AGENT_MODEL;
}
//# sourceMappingURL=agent-runtime-contract.js.map